import { render, staticRenderFns } from "./Dounut.vue?vue&type=template&id=0ab317ea&scoped=true"
import script from "./Dounut.vue?vue&type=script&lang=js"
export * from "./Dounut.vue?vue&type=script&lang=js"
import style0 from "./Dounut.vue?vue&type=style&index=0&id=0ab317ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab317ea",
  null
  
)

export default component.exports